import { z } from 'zod';
import { PaymentMethodDataSchema } from './payment-methods';
// Schema for system, which contains defaults for the app
// Customer Schema - For all customer related data
export var DebtTrackerPaymentTypeEnum;
(function (DebtTrackerPaymentTypeEnum) {
    DebtTrackerPaymentTypeEnum["PAYMENT"] = "PAYMENT";
    DebtTrackerPaymentTypeEnum["DEBT"] = "DEBT";
})(DebtTrackerPaymentTypeEnum || (DebtTrackerPaymentTypeEnum = {}));
export const DebtTrackerPaymentEnumSchema = z.nativeEnum(DebtTrackerPaymentTypeEnum);
// export const DebtTrackerPaymentType = Type.Enum(["CASH", "CARD", "CHECK", "OTHER"]);
export const DebtTrackerTransactionsSchema = z.object({
    id: z.string(),
    amount: z.number(),
    date: z.string(),
    description: z.string(),
    type: DebtTrackerPaymentEnumSchema,
    salesId: z.string().optional().nullable(),
});
export const DebtTrackerSchema = z.object({
    id: z.string(),
    balance: z.number(),
    transactions: z.array(DebtTrackerTransactionsSchema),
});
export const CustomerDataSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    phone: z.string(),
    debtTracker: DebtTrackerSchema.nullable(),
    paymentMethods: PaymentMethodDataSchema.array().nullable().optional(),
});
export const CustomerStoreFieldSchema = z.object({
    customerList: z.array(CustomerDataSchema),
    // Note: setter functions are typically not included in the Typebox schema
});
